export default __webpack_public_path__ + "static/media/bauhaus-feedback-2.0f09219d.png";